import { EntityType } from '../../../../api/targeting/enum/entity.type.enum';
import {
    PortfolioApiModel,
    PortfolioMetadataApiModel,
} from '../../../../api/targeting/model/targeting-list-api.model';
import { PortfolioCategory } from '../../enums/portfolio-category.enum';
import { PortfolioRegion } from '../../enums/portfolio-region.enum';
import { SortFieldEnum } from '../../../../Common/TargetingShared/enum/SortField.enum';

export class PortfolioModel {
    targetingListId: number;
    metadata: PortfolioMetadataModel;
    count: number;

    constructor(apiModel?: PortfolioApiModel, localeString?: string) {
        if (apiModel) {
            this.targetingListId = apiModel.targetingListId;
            this.metadata = new PortfolioMetadataModel(apiModel.metadata, localeString);
            this.count = apiModel.count;
        }
    }
}

export class PortfolioMetadataModel {
    displayName: string;
    entityType: EntityType;
    region: PortfolioRegion;
    category: PortfolioCategory;
    active: boolean;
    defaultSortField: SortFieldEnum;

    constructor(apiModel?: PortfolioMetadataApiModel, localeString?: string) {
        if (apiModel) {
            this.entityType = apiModel.entityType;
            this.active = apiModel.active;
            this.category = apiModel.category;
            this.region = apiModel.region;
            this.defaultSortField = apiModel.defaultSortField;

            if (localeString) {
                this.displayName = apiModel.displayNames.find(x => x.locale === localeString)?.value;
            }
            if (!this.displayName && apiModel.displayNames.length > 0) {
                this.displayName = apiModel.displayNames[0].value;
            }
        }
    }
}
